<div class="page-head">

  <div class="row " style="padding-bottom: 2%;">
    <div class="col-md-5">
      <span>{{'ChooseCase' | translateOrgSpecific}}</span>
    </div>
    <div class="col-md-7 text-center">
      <button class="btn btn-sm float-right btn-apportis-tertiary" type="submit" (click)="newcase()">
        <i class="fas fa-plus-circle" style="color: #ffffff;" aria-hidden="true"></i>
        {{'NewCase' | translateOrgSpecific}}</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class=" search-box-align">
        <div class="input-icons">
          <i class="fas fa-search" style="padding:7px;"></i>
          <input class="search-txt-box form-control  " type="text" [(ngModel)]="searchText" autocomplete="true">
        </div>


      </div>
    </div>

  </div>

</div>


<hr>
<div class="modal-body">

<div *ngIf="participantlist.length  == 0" style="text-align: center;"> <label>{{'NoCasesFound' | translateOrgSpecific}}</label></div>

  <div class="card-data d-flex" style="height: 200px;overflow: auto;">
    <div *ngFor="let ele of participantlist   | caseSearchfilter:searchText" class="case-list">
      <div>

        <div class="card" style=" cursor: pointer;padding-top: 10px;padding-bottom: 10px;"
          [ngClass]="{'highlight':ele.isHighlight,'noHighlight':!ele.isHighlight}" (click)="CardClick(ele)"
          name="ele.case_id">
          <div class="row" style=" cursor: pointer;">
            <!-- <div class="col-md-2">
              <img *ngIf="ele.profileUrl"
                style="height:35px;margin-top: 20px;margin-left: 5px;border-radius: 16px;width: 35px;vertical-align: top;"
                class="img-circle" [src]="ele.profileUrl">
              <i *ngIf="!ele.profileUrl" class="fas fa-user-circle img-circle "
                style="font-size:25px;vertical-align: super; padding: 27px 5px 25px 7px;"></i>
            </div> -->
            <div class="col-md-12">
              <div style="float:left">
                <img *ngIf="ele.profileUrl"
                style="height:35px;margin-top: 15px;margin-left: 10px;margin-right: 5px; border-radius: 16px;width: 35px;vertical-align: top;"
                class="img-circle" [src]="ele.profileUrl">
              <i *ngIf="!ele.profileUrl" class="fas fa-user-circle img-circle "
                style="font-size:25px;margin: 15px 0px 20px 10px;"></i>
              </div>
              <div style="margin-left: 60px;">
                <label style="font-weight: bold;">{{ele.participantName}}</label> <br>
                <label style="font-size: 14px;">{{'Case' | translateOrgSpecific}} : {{ele.issueCategoryName }}</label>
              </div>
            </div>

          </div>
        </div>

      </div>

   
    </div>


  </div>



</div>

<div class="modal-footer">
  <div>
    <button (click)="closeModal()" class="btn btn-sm btn-apportis-tertiary btn-cancel"
      type="submit">{{'Cancel' | translateOrgSpecific}}</button>

    <button class="btn btn-sm btn-apportis-tertiary " (click)="CreateAppointment()" type="submit"
      [disabled]="selectedCases.length == 0"><i class="fas fa-plus-circle" style="color: #ffffff;"
        aria-hidden="true"></i> {{'CreateAppointment' | translateOrgSpecific}} </button>
  </div>
</div>